var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 73,
    viewBox: "0 0 51 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1949 12.1691H44.1869C44.038 11.9209 43.8394 11.6727 43.5912 11.4245L35.6985 3.53171C35.4999 3.33316 35.2517 3.1346 34.9539 2.93604V10.8784C34.9539 11.623 35.4999 12.1691 36.1949 12.1691Z",
    fill: "#612CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1947 15.4948C33.6631 15.4948 31.6279 13.4596 31.6279 10.928V2.24097H11.2258C10.0345 2.24097 8.94238 2.68773 8.0985 3.53161C7.25462 4.37549 6.80786 5.46757 6.80786 6.65893V44.9314C6.80786 47.3637 8.79346 49.3493 11.2258 49.3493H40.4638C42.8961 49.3493 44.8817 47.3637 44.8817 44.9314V15.4948H36.1947ZM25.82 40.9602C20.8063 40.9602 16.7359 36.8897 16.7359 31.876C16.7359 26.8624 20.8063 22.7919 25.82 22.7919C30.8336 22.7919 34.9041 26.8624 34.9041 31.876C34.9041 36.8897 30.8336 40.9602 25.82 40.9602Z",
    fill: "#612CA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6782 28.2524C24.0328 27.8553 23.189 28.302 23.189 29.0963V34.6559C23.189 35.4005 24.0328 35.8969 24.6782 35.4998L29.1458 32.72C29.7414 32.3229 29.7414 31.4293 29.1458 31.0819L24.6782 28.2524Z",
    fill: "#612CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9d17b79f40ff5ca91a7b51dc568fa79d.svg";
export { ForwardRef as ReactComponent };